:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: var(--event-map-height, 100%);
  min-height: var(--event-map-min-height, 380px);
  color: #17122b;
  font-family:
    Inter,
    ui-sans-serif,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  font-size: 16px;
  line-height: 1.5;
  text-align: start;
  direction: ltr;
  color-scheme: light;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
.event-map-embed {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: inherit;
  overflow: hidden;
  isolation: isolate;
  border-radius: var(--event-map-radius, 20px);
  background: #f1f5f7;
}
.event-map-embed__content {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: inherit;
}
.event-map-embed__content > .event-map-root {
  flex: 1;
  min-height: inherit;
}
/* The embed owns clipping; the map itself must not draw a second frame. */
.event-map-embed .event-map-root .venue-map {
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.event-map-embed__status {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  text-align: center;
}
.event-map-embed__status p {
  max-width: 32em;
  margin: 0;
  color: #625d72;
}
.event-map-embed__status h2 {
  margin: 0;
  color: #17122b;
  font-size: 20px;
  font-weight: 650;
}
.event-map-embed__status button {
  appearance: none;
  border: 1px solid #d4cbdc;
  background: #fff;
  border-radius: 999px;
  color: #17122b;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 18px;
  min-height: 44px;
  cursor: pointer;
}
.event-map-embed__status button:hover {
  border-color: #d60078;
}
.event-map-embed__status button:focus-visible {
  outline: 3px solid #d60078;
  outline-offset: 3px;
}
.event-map-embed__spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #ddd4e1;
  border-top-color: #d60078;
  border-radius: 50%;
  animation: event-map-embed-spin 1s linear infinite;
}
@keyframes event-map-embed-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .event-map-embed__spinner {
    animation: none;
    border-color: #d60078;
  }
}
@media (max-width: 600px) {
  :host {
    min-height: var(--event-map-min-height, 400px);
  }
  .event-map-embed {
    border-radius: var(--event-map-radius, 16px);
  }
}
